<template>
	<div>
		<div v-if="!loggedIn" class="table-login">
            <input type="button" value="войти в чат" @click="performLogin()">
		</div>
		<div v-if="loggedIn">
            <input type="button" value="выйти" @click="logout()">
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	components: {
    },
	props: [],
	data() {
		return {
			login: '',
			password: ''
		};
	},
	computed: {
		...mapGetters({
	        	loggedIn: 'chat/loggedIn',
	        	storedLogin: 'chat/login',
	        	storedPassword: 'chat/password'
	       	})
	},
	methods: {
		performLogin() {
			this.$store.dispatch('chat/connectWithCreds', {
				login: this.login,
				password: this.password
			});
		},
		logout() {
            this.$store.dispatch('chat/logout');
            this.$emit('logout');
		}
	},
	created() {
		this.login = this.storedLogin;
		this.password = this.storedPassword;
	}
};
</script>

<style scoped lang="less">
	input[type="button"]{
        width: 50%;
        height: 48px;
        border-radius: 4px;
        background-color: #0fd7b7;
        border: none;
        box-sizing: border-box;
        color: #374b62;
        cursor: pointer;
        font-family: Arimo;
        font-size: 13px;
        font-weight: bold;
        margin-bottom: 4px;
}
</style>